import React, { useState } from "react";

import Swal from "sweetalert2";
import { intervalToDuration } from "date-fns";

import { Box, Flex, Link, Text, useDisclosure } from "@chakra-ui/react";

import { Link as ReactLink, useHistory } from "react-router-dom";

import { FiltersCriancas } from "../../components/FiltersCriancas";
import { TableCriancas } from "../../components/TableCriancas";
import LoadingSpinner from "../../components/LoadingSpinner";
import {
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../Context/AuthProvider";
import { useAppContext } from "../../../Context/MessageContextProvider";

export const Criancas = () => {
  const [loading, setLoading] = useState(false);
  const { roleKeycloack, user } = useAuthProvider();
  const { idPJ } = useAppContext();

  const history = useHistory();
  const [name, setName] = useState("");
  const {
    isOpen: isOpenNovoAcolhimento,
    onOpen: onOpenNovoAcolhimento,
    onClose: onCloseNovoAcolhimento,
  } = useDisclosure();
  const [atualizarDadosTabela, setAtualizarDadosTabela] = useState(false);
  const columns = [
    {
      Header: "Nome/Nome Social",
      accessor: "nome",
      sortType: (rowA, rowB, id, desc) => {
        let nameA = rowA.original.nome;
        let nameB = rowB.original.nome;
        if (rowA.original.nomeSocial) {
          nameA = nameA + " / " + rowA.original.nomeSocial;
        }
        if (rowB.original.nomeSocial) {
          nameB = nameB + " / " + rowB.original.nomeSocial;
        }

        return nameA.localeCompare(nameB, "pt-BR");
      },
      Cell: (props) => {
        const id = props?.row?.original?.id;
        let name = props?.row?.original?.nome;
        let ultimaMovimentacao = props?.row?.original?.movimentacoes[0];

        let temRiscoVida = false;
        let ultimaMovimentacaoRisco;

        if (ultimaMovimentacao?.idMovimento !== 2) {
          ultimaMovimentacaoRisco = props?.row?.original?.movimentacoes[0];
        }

        if (props.row.original.nomeSocial) {
          name = name + " / " + props.row.original.nomeSocial;
        }

        if (
          props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
          props?.row?.original?.movimentacoes[0]?.idMovimento === 6
        ) {
          const movimentacoes = props?.row?.original?.movimentacoes || [];

          for (const mov of movimentacoes) {
            if (mov?.idMovimento === 3 || !mov?.idMovimento) {
              temRiscoVida = mov?.riscoVidaMotivoSituacao === "S";
              break;
            }
          }
        }

        return (roleKeycloack &&
          roleKeycloack.includes(criancaFunc.visualizar)) ||
          roleKeycloack.includes(
            servicoAcolhimentoFunc.visualizarPartePPCAAM
          ) ? (
          (ultimaMovimentacaoRisco?.riscoVidaMotivoSituacao === "N" ||
            !ultimaMovimentacaoRisco?.riscoVidaMotivoSituacao) &&
          !temRiscoVida ? (
            <Link
              wordBreak={"break-all"}
              title={name}
              as={ReactLink}
              to={"/crianca/" + id}
            >
              <Flex alignItems="center" gap={2}>
                {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" &&
                ultimaMovimentacao?.idMovimento === 2 ? (
                  <Box
                    w="4"
                    h="4"
                    bg="#169499"
                    borderRadius="full"
                    border="1px"
                    color="#169499"
                  />
                ) : ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
                  ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
                  <Box w="3" h="3" borderRadius="full" />
                ) : (
                  <Box
                    w="4"
                    h="4"
                    bg="red"
                    borderRadius="full"
                    border="1px"
                    color="red"
                  />
                )}
                <Text minWidth="250px">{name}</Text>
              </Flex>
            </Link>
          ) : (
            <Link
              wordBreak={"break-all"}
              title={name}
              onClick={() =>
                riscoAlert(
                  id,
                  props?.row?.original?.servicoAcolhimento?.idPessoaJuridica,
                  props?.row?.original?.movimentacoes[0]?.idMovimento
                )
              }
            >
              <Flex alignItems="center" gap={2}>
                {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" &&
                ultimaMovimentacao?.idMovimento === 2 ? (
                  <Box
                    w="4"
                    h="4"
                    bg="#169499"
                    borderRadius="full"
                    border="1px"
                    color="#169499"
                  />
                ) : ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
                  ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
                  <Box w="3" h="3" borderRadius="full" />
                ) : (
                  <Box
                    w="4"
                    h="4"
                    bg="red"
                    borderRadius="full"
                    border="1px"
                    color="red"
                  />
                )}
                <Text minWidth="250px">{name}</Text>
              </Flex>
            </Link>
          )
        ) : ultimaMovimentacao?.riscoVidaMotivoSituacao === "N" ||
          !ultimaMovimentacao?.riscoVidaMotivoSituacao ? (
          <Flex alignItems="center" gap={2}>
            {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
            ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
              <Box w="3" h="3" borderRadius="full" />
            ) : (
              <Box
                w="3"
                h="3"
                bg="red"
                borderRadius="full"
                F
                border="1px"
                color="red"
              />
            )}
            <Text minWidth="250px">{name}</Text>
          </Flex>
        ) : (
          <Flex alignItems="center" gap={2}>
            {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
            ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
              <Box w="3" h="3" borderRadius="full" />
            ) : (
              <Box
                w="3"
                h="3"
                bg="red"
                borderRadius="full"
                border="1px"
                color="red"
              />
            )}
            <Text minWidth="250px">{name}</Text>
          </Flex>
        );
      },
    },
    {
      Header: "Idade",
      accessor: "dataNascimento",
      sortType: (rowA, rowB, id, desc) => {
        const idadeA = rowA.original.dataNascimento
          ? intervalToDuration({
              start: new Date(rowA.original.dataNascimento),
              end: new Date(),
            }).years.toString()
          : "";
        const idadeB = rowB.original.dataNascimento
          ? intervalToDuration({
              start: new Date(rowB.original.dataNascimento),
              end: new Date(),
            }).years.toString()
          : "";
        if (Number(idadeA) > Number(idadeB)) return 1;
        if (Number(idadeB) > Number(idadeA)) return -1;
      },
      Cell: (props) => {
        const idade = props?.value
          ? intervalToDuration({
              start: new Date(props.value),
              end: new Date(),
            }).years
          : "";
        return <span>{idade}</span>;
      },
    },
    {
      Header: "Filiação",
      accessor: "filiacoes",
      sortType: (rowA, rowB, id, desc) => {
        const filiacoesA = rowA?.original?.filiacoes?.length
          ? rowA.original.filiacoes
              .map((filiacao) => filiacao?.filiacao?.nome || "")
              .reduce((prev, filiacao) => prev + filiacao, "")
          : "";
        const filiacoesB = rowB?.original?.filiacoes?.length
          ? rowB.original.filiacoes
              .map((filiacao) => filiacao?.filiacao?.nome || "")
              .reduce((prev, filiacao) => prev + filiacao, "")
          : "";
        return filiacoesA.localeCompare(filiacoesB, "pt-BR");
      },
      Cell: (props) => {
        return props?.value
          .sort((a, b) =>
            a.tipoRelacionamento.localeCompare(b.tipoRelacionamento)
          )
          .map((filiacao, index) => {
            return (
              <React.Fragment key={index}>
                <span style={{ whiteSpace: "nowrap" }}>
                  {filiacao?.nome}{" "}
                  <Text as="span" textTransform="capitalize">
                    ({filiacao?.tipoRelacionamento.toLowerCase()})
                  </Text>
                </span>
                {props.value.length - 1 !== index && <br />}
              </React.Fragment>
            );
          });
      },
    },
    {
      Header: "Serviço de Acolhimento",
      accessor: "servicoAcolhimento",
      sortType: (rowA, rowB, id, desc) => {
        const nomeServicoA = rowA?.original?.servicoAcolhimento
          ? rowA.original.servicoAcolhimento.nomeFantasia
          : "";
        const nomeServicoB = rowB?.original?.servicoAcolhimento
          ? rowB.original.servicoAcolhimento.nomeFantasia
          : "";
        return nomeServicoA?.localeCompare(nomeServicoB, "pt-BR");
      },
      Cell: (props) => {
        const permissaoServico =
          roleKeycloack.includes(criancaFunc.visualizarTudo) ||
          roleKeycloack.includes(
            servicoAcolhimentoFunc.visualizarPartePPCAAM
          ) ||
          roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteMP) ||
          roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteTJ) ||
          ((roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
            roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
            user?.orgaoExterno?.includes(
              props?.row?.original?.servicoAcolhimento?.idPessoaJuridica
            ));
        let temRiscoVida = false;

        if (
          props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
          props?.row?.original?.movimentacoes[0]?.idMovimento === 2 ||
          props?.row?.original?.movimentacoes[0]?.idMovimento === 6
        ) {
          const movimentacoes = props?.row?.original?.movimentacoes || [];

          for (const mov of movimentacoes) {
            if (mov?.idMovimento === 3 || !mov?.idMovimento) {
              temRiscoVida = mov?.riscoVidaMotivoSituacao === "S";
              break;
            }
          }
        }

        if (
          (props?.row?.original?.movimentacoes[0]?.riscoVidaMotivoSituacao ===
            "S" &&
            !permissaoServico) ||
          (!permissaoServico &&
            (props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
              props?.row?.original?.movimentacoes[0]?.idMovimento === 2 ||
              props?.row?.original?.movimentacoes[0]?.idMovimento === 6) &&
            temRiscoVida)
        ) {
          return <span></span>;
        } else {
          const idServico = props?.row?.original?.servicoAcolhimento?.id;
          if (!idServico) {
            return <span></span>;
          } else {
            return (
              <>
                {roleKeycloack &&
                roleKeycloack.includes(servicoAcolhimentoFunc.visualizar) ? (
                  <Link
                    wordBreak={"break-word"}
                    title={
                      props.value
                        ? props.value.nomeFantasia +
                          `${
                            props?.value?.suspenso === "S" ? " (Suspenso)" : ""
                          }`
                        : ""
                    }
                    as={ReactLink}
                    to={"/servico-acolhimento/" + idServico}
                  >
                    <Text>
                      {" "}
                      {props.value
                        ? props.value.nomeFantasia +
                          `${
                            props?.value?.suspenso === "S" ? " (Suspenso)" : ""
                          }`
                        : ""}
                    </Text>
                  </Link>
                ) : (
                  <Text>
                    {props.value
                      ? props.value.nomeFantasia +
                        `${props?.value?.suspenso === "S" ? " (Suspenso)" : ""}`
                      : ""}
                  </Text>
                )}
              </>
            );
          }
        }
      },
    },
    {
      Header: "Tempo de Permanência",
      accessor: "tempoPermanencia",
      Cell: (props) => {
        const permissaoServico =
          roleKeycloack.includes(criancaFunc.pesquisarRisco) ||
          ((roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
            roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
            user?.orgaoExterno?.includes(
              props?.row?.original?.servicoAcolhimento?.idPessoaJuridica
            ));
        let temRiscoVida = false;

        if (
          props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
          props?.row?.original?.movimentacoes[0]?.idMovimento === 2 ||
          props?.row?.original?.movimentacoes[0]?.idMovimento === 6
        ) {
          const movimentacoes = props?.row?.original?.movimentacoes || [];

          for (const mov of movimentacoes) {
            if (mov?.idMovimento === 3 || !mov?.idMovimento) {
              temRiscoVida = mov?.riscoVidaMotivoSituacao === "S";
              break;
            }
          }
        }

        if (
          (props?.row?.original?.movimentacoes[0]?.riscoVidaMotivoSituacao ===
            "S" &&
            !permissaoServico) ||
          (!permissaoServico &&
            (props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
              props?.row?.original?.movimentacoes[0]?.idMovimento === 2 ||
              props?.row?.original?.movimentacoes[0]?.idMovimento === 6) &&
            temRiscoVida)
        ) {
          return <Text>{""}</Text>;
        } else {
          return <Text>{props.value ?? ""}</Text>;
        }
      },
    },
  ];

  const [data, setData] = useState();

  const riscoAlert = (id, idPJCrianca, idMovimento) => {
    if (
      idMovimento !== 2 &&
      !roleKeycloack.includes(criancaFunc.pesquisarRisco) &&
      !(
        (roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
          roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJCrianca)
      )
    ) {
      Swal.fire({
        title: "Por favor, entre em contato com o Gestor do MCA.",
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonColor: "#169499",
        cancelButtonText: "Voltar",
      });
    } else {
      history.push("/crianca/" + id);
    }
  };

  return (
    <Flex
      flex={1}
      flexDir="column"
      px={["5px", "32px"]}
      pb="20px"
      alignItems="center"
      overflow="auto"
    >
      <FiltersCriancas
        data={data}
        setData={setData}
        setLoading={setLoading}
        loading={loading}
        entidade="crianca"
        roleKeycloack={roleKeycloack}
        atualizarDadosTabela={atualizarDadosTabela}
        setAtualizarDadosTabela={setAtualizarDadosTabela}
        setName={setName}
      />
      {!loading ? (
        data && (
          <TableCriancas
            data={data.content}
            columns={columns}
            isOpenNovoAcolhimento={isOpenNovoAcolhimento}
            onOpenNovoAcolhimento={onOpenNovoAcolhimento}
            onCloseNovoAcolhimento={onCloseNovoAcolhimento}
            entidade="crianca"
            atualizarDadosTabela={atualizarDadosTabela}
            setAtualizarDadosTabela={setAtualizarDadosTabela}
            roleKeycloack={roleKeycloack}
            user={user}
            name={name}
            setData={setData}
            idPJ={idPJ}
          />
        )
      ) : (
        <>
          <LoadingSpinner />
        </>
      )}
    </Flex>
  );
};
